<template>
    <div class="income-generalization">
        <div class="not-authentication-master" v-if="!userInfo.isMaster">
            <div class="authentication-links" v-if="!infoData.publisher || !infoData.publisher.auditstatus">
                <a class="authentication-link" v-for="item in authenticationLinks" :key="item.value" :class="[
                    item.value,
                    {
                        disable: item.disable
                    }
                ]" href="javascript:" @click="!item.disable && openAuthenticationMasterDialog(item.value, false)">
                    <label v-if="item.disable">
                        敬请期待
                    </label>
                    {{ item.name }}
                </a>
            </div>
            <div class="authentication-state state1" v-if="infoData.publisher.auditstatus == 2">
                <div class="state-text" @click="openAuthenticationMasterDialog(infoData.publisher.publishertype, true)">
                    {{ infoData.publisher.publishertype === 'enterprise' ? '企业' : '个人' }}认证在审核中
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="authentication-state state2" v-if="infoData.publisher.auditstatus == 4">
                <div class="state-text" @click="openAuthenticationMasterDialog(infoData.publisher.publishertype, true)">
                    {{ infoData.publisher.publishertype === 'enterprise' ? '企业' : '个人' }}认证未通过，请重新认证
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="authentication-links">
                    <a class="authentication-link" v-for="item in authenticationLinks" :key="item.value" :class="[
                        item.value,
                        {
                            disable: item.disable
                        }
                    ]" href="javascript:" @click="!item.disable && openAuthenticationMasterDialog(item.value, false)">
                        <label v-if="item.disable">
                            敬请期待
                        </label>
                        {{ item.name }}
                    </a>
                </div>
            </div>
            <img src="./images/img_authentication_master.png" alt=""/>
        </div>
        <div class="authentication-master" v-else>
            <div class="master-info-box">
                <div class="info-box">
                    <div class="master-info">
                        <img class="master-avatar" :src="infoData.shop.profilepicattach"/>
                        <div class="info">
                            <div class="master-name">
                                {{ infoData.shop.shopname }}
                            </div>
                            <div>
                                <div class="authentication" :class="[infoData.publisher.publishertype]">
                                    创享达人-{{
                                        infoData.publisher.publishertype === 'enterprise' ? '企业' : '个人'
                                    }}认证
                                </div>
                                <div class="profit-ratio">
                                    分润比例：{{ infoData.publisher.publishertype === 'enterprise' ? 60 : 50 }}%
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shop-info">
                        <h5>
                            店铺介绍
                        </h5>
                        <p :title="infoData.shop.introduce">
                            {{ infoData.shop.introduce }}
                        </p>
                    </div>
                </div>
                <div class="earnings-info">
                    <div class="earnings">
                        <div class="earnings-item">
                            <div class="item-name">
                                今日收入
                            </div>
                            <div class="item-value">
                                <span>{{ userInfo.todayEarnings }}</span>元
                            </div>
                        </div>
                        <div class="earnings-item">
                            <div class="item-name">
                                累计收入
                            </div>
                            <div class="item-value">
                                <span>{{ userInfo.cumulativeIncome }}</span>元
                            </div>
                        </div>
                        <div class="earnings-item" v-if="infoData.publisher.publishertype === 'enterprise'">
                            <div class="item-name">
                                上架素材
                            </div>
                            <div class="item-value">
                                <span>{{ userInfo.materialNum }}</span>份
                            </div>
                        </div>
                    </div>
                    <div class="balance">
                        <p>
                            <label>
                                可提现金额
                                <!-- <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="infoData.withdrawTip"
                                    placement="bottom"
                                > -->
                                <i class="el-icon-warning-outline"></i>
                                <!-- </el-tooltip> -->
                            </label>
                            每月1号至7号可提现一次，{{ minWithdrawPrice }}元起兑
                        </p>
                        <div class="balance-value">
                            <span> {{ userInfo.accountBalance }} </span>元
                            <el-button type="primary" plain size="small" @click="withdraw">去提现</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="earnings-list-box">
                <div class="info-tt">
                    收益台帐
                </div>
                <div class="earnings-list-searchbar">
                    <div class="searchbar-item">
                        素材名称：
                        <el-input size="small" v-model="keyword" placeholder="请输入"></el-input>
                    </div>
                    <div class="searchbar-item">
                        时间筛选：
                        <el-date-picker v-model="date" size="small" type="daterange" range-separator="-"
                                        start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd" clearable>
                        </el-date-picker>
                    </div>
                    <el-button type="primary" size="small" @click="searchEarningsList">搜索</el-button>
                </div>
                <div v-show="listData.total">
                    <el-table :data="listData.list" style="width: 100%">
                        <el-table-column prop="index" label="序" width="60px">
                            <template slot-scope="scope">
                            <span :title="scope.row.index">
                            {{ scope.row.index }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="materialtitle" label="素材名称">
                            <template slot-scope="scope">
                            <span :title="scope.row.materialtitle">
                            {{ scope.row.materialtitle }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="suredate" label="下单时间">
                            <template slot-scope="scope">
                            <span :title="scope.row.suredate">
                            {{ scope.row.suredate }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="paymoney" label="订单金额 (元)" width="150px">
                            <template slot-scope="scope">
                            <span :title="scope.row.paymoney">
                            {{ scope.row.paymoney }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sharingrate" label="分成比例 (%)" width="150px">
                            <template slot-scope="scope">
                            <span :title="scope.row.sharingrate">
                            {{ scope.row.sharingrate }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="income" label="获得收益金额 (元)" width="150px">
                            <template slot-scope="scope">
                            <span :title="scope.row.income">
                            {{ scope.row.income }}
                            </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                   :current-page="listParams.pageindex + 1" :page-sizes="[5, 10, 20, 50]"
                                   :page-size="listParams.pagesize" background
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="listData.total">
                    </el-pagination>
                </div>
                <div v-show="!listData.total && listData.isLoad" class="none-data-box">
                    <div class="none-data">
                        暂无数据
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="创享达人认证" :visible.sync="authenticationMasterDialog.show" width="800px"
                   custom-class="authentication-master-dialog" @close="closeAuthenticationMasterDialog" append-to-body
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <authentication-company-master-dialog
                v-if="authenticationMasterDialog.show && authenticationMasterDialog.type == 'enterprise'"
                :is-detail="authenticationMasterDialog.isDetail"
                @closeDialog="closeAuthenticationMasterDialog"></authentication-company-master-dialog>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import AuthenticationCompanyMasterDialog from './authentication-company-master-dialog.vue';

export default {
    name: 'IncomeGeneralization',
    components: {
        AuthenticationCompanyMasterDialog
    },
    data() {
        return {
            authenticationLinks: [
                {
                    name: '企业认证',
                    value: 'enterprise',
                    disable: false
                },
                {
                    name: '个人认证（敬请期待）',
                    value: 'person',
                    disable: true
                }
            ],
            infoData: {
                publisher: {},
                shop: {}
            },
            authenticationMasterDialog: {
                show: false,
                guid: '',
                type: ''
            },
            minWithdrawPrice: 10,
            keyword: '',
            date: [],
            listParams: {
                pageindex: 0,
                pagesize: 10,
                searchtext: '',
                startdate: '',
                enddate: ''
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        this.getMasterInfo();
    },
    methods: {
        ...mapActions(['getUserInfo']),
        getMasterInfo() {
            this.$Api
                .getMasterInfo({
                    userguid: this.userInfo.userguid,
                    shopguid: '',
                    ishomepage: '0'
                })
                .then((data) => {
                    this.infoData = data;
                    if (data.publisher.auditstatus == 3) {
                        this.getEarningsList();
                    } else if (data.publisher.auditstatus == 4) {
                        this.authenticationLinks = [
                            {
                                name: '个人认证（敬请期待）',
                                value: 'person',
                                disable: true
                            }
                        ]
                    }
                });
        },
        openAuthenticationMasterDialog(type = 'enterprise', isDetail = false) {
            if (!isDetail) {
                this.$confirm('认证对象类型一旦确认后将不可变更，确认是否继续？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.authenticationMasterDialog.type = type;
                    this.authenticationMasterDialog.isDetail = isDetail;
                    this.authenticationMasterDialog.show = true;
                });
            } else {
                this.authenticationMasterDialog.type = type;
                this.authenticationMasterDialog.isDetail = isDetail;
                this.authenticationMasterDialog.show = true;
            }
        },
        closeAuthenticationMasterDialog() {
            this.authenticationMasterDialog.show = false;
            this.authenticationMasterDialog.type = '';
            this.authenticationMasterDialog.isDetail = false;
            this.getUserInfo();
            this.getMasterInfo();
        },
        searchEarningsList() {
            this.listParams.searchtext = this.keyword;
            this.listParams.startdate = this.date && this.date.length ? this.date[0] : '';
            this.listParams.enddate = this.date && this.date.length ? this.date[1] : '';
            this.listParams.pageindex = 0;
            this.getEarningsList();
        },
        getEarningsList() {
            let params = {
                ...this.listParams,
                relationguid: this.userInfo.userguid
            };
            this.$Api.getEarningsList(params).then((data) => {
                this.listData.list = data.incomelist.map((item, index) => {
                    item.index = this.listParams.pageindex * this.listParams.pagesize + index + 1;
                    return item;
                });
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
            });
        },
        handleSizeChange(e) {
            this.listParams.pagesize = e;
            this.getEarningsList();
        },
        handleCurrentChange(e) {
            this.listParams.pageindex = e - 1;
            this.getEarningsList();
        },
        withdraw() {
            this.$emit('jumpToTab', {
                tab: 2,
                fn: 'openWithdrawalDialog'
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/income-generalization.scss';
</style>
